var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.204 4.9 5.618-1.7a3.58 3.58 0 0 1 .263 5.374 3.573 3.573 0 0 1-5.887-3.657l.006-.019Zm15.492 2.374-1.627 5.38a3.064 3.064 0 1 1 1.615-5.39z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.885 18.998a3.063 3.063 0 1 0 4.332-4.332 3.063 3.063 0 0 0-4.332 4.332",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.26.044a1 1 0 0 1 1.245 1.247l-1.809 5.983-.012-.01a3.063 3.063 0 1 0-1.614 5.39l-4.202 13.9a3 3 0 0 0-1.026-.84c-.145-.073-.34-.16-.58-.27-1.65-.744-5.415-2.444-9.64-6.67-4.156-4.154-5.985-7.813-6.934-9.71l-.004-.008A3 3 0 0 0 4.537 7.82l9.665-2.922-.006.019a3.573 3.573 0 1 0 5.63-1.712L19.82 3.2zm-9.043 18.953a3.063 3.063 0 1 1-4.332-4.332 3.063 3.063 0 0 1 4.332 4.332",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.658 7.714a3 3 0 0 1 4.025 1.341l.004.01c.95 1.896 2.778 5.555 6.934 9.711 4.225 4.224 7.99 5.924 9.64 6.67.24.107.436.195.58.268a3 3 0 1 1-2.683 5.366q-.21-.1-.425-.194c-1.567-.699-6.293-2.806-11.355-7.867C3.54 18.18 1.368 13.844.316 11.74A3 3 0 0 1 1.66 7.714Z",
    clipRule: "evenodd",
    opacity: 0.4
  })));
};
export default SvgMeal;